
define('jst!notifications/push/sticky_notification',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="notification flashmessage <%=style%>">\n  <div class="inner">\n    <div class="image-block message">\n      <div class="img icon">\n        <div class="<%=icon%>"></div>\n      </div>\n\n      <div class="bd text">\n        <h4 class="text-bold"><%- text %></h4>\n      </div>\n    </div>\n    <a class="icon-16 icon-x-black close-button close-sticky"></a>\n  </div>\n</li>\n');
 });

